import { Reference } from '@approvalmax/types';
import { mathService } from '@approvalmax/utils';
import { NetSuiteContextType } from 'pages/requestForm/reducers/page/netSuiteContextReducer';
import { useMemo } from 'react';

import { useCurrencyPrecision } from '../useCurrencyPrecision/useCurrencyPrecision';

export const useDiscountAmountValue = (
    terms: NetSuiteContextType['terms'],
    selectedTermId: string | undefined,
    netAmount: number,
    currency: Reference | null | undefined
) => {
    const selectedTerm = useMemo(() => terms.find((term) => term.id === selectedTermId), [terms, selectedTermId]);

    const currencyPrecision = useCurrencyPrecision(currency);

    return useMemo(() => {
        if (typeof selectedTerm?.discountPercent === 'number') {
            const value = mathService.multiply(netAmount, selectedTerm.discountPercent / 100);

            return mathService.round(value, currencyPrecision);
        }

        return null;
    }, [selectedTerm, netAmount, currencyPrecision]);
};
